import React from 'react';
import cn from 'classnames';
import styles from './index.css';

export default ({ className }) => (<div className={cn(styles.component, className)} />);
